import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from './ui';
import type { IssuedKey } from '../lib/api';

/**
 * The instance credentials, shown exactly once (the console keeps only a
 * hash of the key). Presented as the lines to paste into the instance .env.
 */
export function KeyReveal({ issued, consoleUrl }: { issued: IssuedKey; consoleUrl: string }) {
  const [copied, setCopied] = useState(false);
  const envLines = [
    `CONSOLE_URL=${consoleUrl}`,
    `INSTANCE_ID=${issued.instanceId}`,
    `INSTANCE_KEY=${issued.instanceKey}`,
  ].join('\n');

  async function copy() {
    await navigator.clipboard.writeText(envLines);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="space-y-3">
      <p className="rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-amber-200">
        Cheia apare o singură dată. Copiază liniile de mai jos în fișierul <code>.env</code> al
        instanței, apoi rulează <code>docker compose up -d</code> în folderul ei.
      </p>
      <pre className="overflow-x-auto rounded-lg border border-slate-800 bg-slate-950 p-3 text-xs text-slate-200">
        {envLines}
      </pre>
      <Button variant="secondary" onClick={() => void copy()}>
        {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        {copied ? 'Copiat' : 'Copiază'}
      </Button>
    </div>
  );
}
